module.exports = __webpack_public_path__ + "img/calm-waters.333893d9.jpg";